import Chip from "@mui/material/Chip"

import Row from "../../../common/components/Row"

export default function ActivityReportStatCapsules({
  analytics,
  loading = false,
  compact = false,
}) {
  const chipSize = compact ? "small" : "medium"

  return (
    <Row gap={1} sx={{ flexWrap: "wrap" }}>
      <Chip
        size={chipSize}
        label={`Sent: ${loading ? "…" : analytics?.reports_sent ?? 0}`}
        color="success"
        variant="outlined"
      />
      <Chip
        size={chipSize}
        label={`Pending: ${loading ? "…" : analytics?.reports_pending ?? 0}`}
        color="warning"
        variant="outlined"
      />
      <Chip
        size={chipSize}
        label={`Failed: ${loading ? "…" : analytics?.reports_failed ?? 0}`}
        color="error"
        variant="outlined"
      />
    </Row>
  )
}
